import { combineReducers } from '@reduxjs/toolkit'
import {pageReducer} from "./reducers";
export const rootReducer = combineReducers({
    pageState: pageReducer
})